<template>
	<div class="body-container" id="h-box">
		<Header :isHome="true" :showHeader="false" :headerMini="headerMini"></Header>
		<div class="home-hero__wrapper">
			<div class="hero-bg"></div>
			<div class="home-hero__headline">
				<h1>Solutions for a Connected World<br></h1>
				<h3 style="color: #E5E5E5;font-size: 28px;margin-bottom: 10px;">Integrated legal solutions to complex
					business challenges</h3><br>
				<a class="home-hero__link link--bold" @click="toPage('/aboutus')">
					<div class="ab-link-block">
						<div class="link--bold-txt">About Us</div>
						<div class="link-spre"></div>
						<div class="iconfont icon-xiangyou1"></div>
					</div>
				</a>
			</div>
			<div class="hero-insights">
				<h3>Latest News</h3>
				<div class="hero-insights__featured carousel">
					<div class="hero-insights__insight carousel-content" tabindex="0" role="group"
						aria-describedby="slick-slide10" style="" aria-roledescription="slide">
						<a class="hero-insights__link"  @click="toPage('/newsroom')" tabindex="0">
							<div class="link-spre"></div>
							<div class="hero-insights__type">News</div>
							<div class="hero-insights__title">Baker McKenzie client Iberdrola completes sale of part of
								its combined cycle business in Mexico for USD 6.2 billion</div>
						</a>
					</div>
					<div class="hero-insights__insight carousel-content" tabindex="-1" role="group"
						aria-describedby="slick-slide11" style="" aria-roledescription="slide">
						<a class="hero-insights__link" @click="toPage('/newsroom')" tabindex="-1">
							<div class="link-spre"></div>
							<div class="hero-insights__type">News</div>
							<div class="hero-insights__title">Baker McKenzie Strengthens Its Private Equity Team with
								Veteran Partner Eric Schwartzman</div>
						</a>
					</div>
					<div class="hero-insights__insight carousel-content" tabindex="-1" role="group"
						aria-describedby="slick-slide12" style="" aria-roledescription="slide">
						<a class="hero-insights__link" @click="toPage('/newsroom')" tabindex="-1">
							<div class="link-spre"></div>
							<div class="hero-insights__type">News</div>
							<div class="hero-insights__title">Baker McKenzie Achieves Top Rankings in Chambers Global
								2024</div>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="cta-module-section">
			<div class="cta-intro__inner">
				<h4 class="cta-intro__header">Solutions for a Connected World</h4>
				<div class="">
					<div class="cta-intro__copy">The global business community is more interconnected than ever before.
						Opportunities and risks spill across different markets, sectors and areas of law, so a connected
						perspective is essential in delivering business objectives while mitigating risk.</div>
					<div class="cta-link-block">
						<div class="link--bold-txt">Explore our legal solutions</div>
						<div class="link-spre"></div>
						<div class="iconfont icon-xiangyou1"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="topic-selector" :style="{backgroundImage: 'url('+ topicBgList[toppicIndex] +')'}">
			<div class="topic-selector__background">

			</div>
			<div class="topic-selector__tiles--four-grid">
				<div class="topic-selector__header" @mouseover="changeTopicBg(0)">
					<div class="topic-selector__tile">Trending Content</div>
				</div>
				<div class="topic-selector__header topic-card-inner" @mouseover="changeTopicBg(1)">
					<div class="topic-selector__title">The Year Ahead Global Disputes Forecast 2024</div>
					<div class="topic-selector__card">
						<div class="topic-selector__card-inner">
							<div class="topic-selector__card-title">The Year Ahead Global Disputes Forecast 2024</div>
							<div class="topic-selector__card-content">Our seventh annual report provides detailed
								analysis of disputes trends, as well as sectoral and region-specific developments, to
								prepare your organization for The Year Ahead.</div>
							<div class="topic-selector__card-link">
								<span class="link--bold link--bold-white">Learn More&nbsp;</span>
							</div>
						</div>
					</div>
				</div>
				<div class="topic-selector__header topic-card-inner" @mouseover="changeTopicBg(2)">
					<div class="topic-selector__title">FT Due Diligence Series</div>
					<div class="topic-selector__card">
						<div class="topic-selector__card-inner">
							<div class="topic-selector__card-title">FT Due Diligence Series</div>
							<div class="topic-selector__card-content">Our lawyers are joined by industry thought leaders
								to discuss the key developments and issues shaping the future of global transactions.
							</div>
							<div class="topic-selector__card-link">
								<span class="link--bold link--bold-white">Learn More&nbsp;</span>
							</div>
						</div>
					</div>
				</div>
				<div class="topic-selector__header topic-card-inner" @mouseover="changeTopicBg(3)">
					<div class="topic-selector__title">Workforce Redesign: Outlooks for Business Leaders</div>
					<div class="topic-selector__card">
						<div class="topic-selector__card-inner">
							<div class="topic-selector__card-title">Workforce Redesign: Outlooks for Business Leaders
							</div>
							<div class="topic-selector__card-content">Explore the biggest factors shaping your
								workforce.</div>
							<div class="topic-selector__card-link">
								<span class="link--bold link--bold-white">Read More&nbsp;</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="cta-module-section">
			<div class="cta-intro__inner">
				<h4 class="cta-intro__header">Committed to Responsible Business</h4>
				<div class="">
					<div class="cta-intro__copy">Lasting, impactful change is only possible when business, government,
						civil society and local communities come together to share expertise, knowledge and resources to
						achieve a shared vision.</div>
					<div class="cta-link-block">
						<div class="link--bold-txt">Read Our Annual Sustainability Report 2023</div>
						<div class="link-spre"></div>
						<div class="iconfont icon-xiangyou1"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="stats-module global-module">
			<div class="stats-module__inner page-wrapper">
				<div class="stats-module__stat scroll-animate scroll-animate--animated">
					<div class="stats-module__stat-number">74</div>
					<div class="stats-module__stat-label">Offices</div>
					<div class="stats-module__stat-shadow scroll-animate scroll-animate--animated">74</div>
				</div>

				<div class="stats-module__stat scroll-animate scroll-animate--animated">
					<div class="stats-module__stat-number">45</div>
					<div class="stats-module__stat-label">Locations</div>
					<div class="stats-module__stat-shadow scroll-animate scroll-animate--animated">45</div>
				</div>

				<div class="stats-module__stat scroll-animate scroll-animate--animated">
					<div class="stats-module__stat-number">#1</div>
					<div class="stats-module__stat-label">Law Firm Brand (Thomson Reuters)</div>
					<div class="stats-module__stat-shadow scroll-animate scroll-animate--animated">#1</div>
				</div>

				<div class="stats-module__stat scroll-animate scroll-animate--animated">
					<div class="stats-module__stat-number">447</div>
					<div class="stats-module__stat-label">Chambers Lawyer Rankings</div>
					<div class="stats-module__stat-shadow scroll-animate scroll-animate--animated">447</div>
				</div>

				<div class="stats-module__stat scroll-animate scroll-animate--animated">
					<div class="stats-module__stat-number">65%</div>
					<div class="stats-module__stat-label">Multijurisdictional Deals</div>
					<div class="stats-module__stat-shadow scroll-animate scroll-animate--animated">65%</div>
				</div>

				<div class="stats-module__stat scroll-animate scroll-animate--animated">
					<div class="stats-module__stat-number">400+</div>
					<div class="stats-module__stat-label">Women Partners</div>
					<div class="stats-module__stat-shadow scroll-animate scroll-animate--animated">400+</div>
				</div>
			</div>
		</div>
		<div class="cta-module-section2 global-module ">
			<div class="call-to-action-module">
				<div class="title">Reinvent by Baker McKenzie</div>
				<div class="content call-to-action__content">
					<div class="summary">Reinvent is our innovation program. It brings together all our change
						initiatives in support of better client outcomes.</div>

					<div class="cta-link-block">
						<a @clickt="toPage('/expertise')" class="link--bold-txt">
							Explore our legal solutions
						</a>
						<div class="link-spre"></div>
						<div class="iconfont icon-xiangyou1"></div>
					</div>


				</div>
			</div>
			<div class="call-img"></div>
		</div>
		<div class="global-footer">
			<div class="communication-footer hide-print">
				<ul class="social-links">
					<li class="social-link"><a class="iconfont icon-tuite" target="_blank"></a></li>
					<li class="social-link"><a class="iconfont icon-f" target="_blank"></a></li>
					<li class="social-link"><a class="iconfont icon-weibiaoti1"target="_blank"></a></li>
					<li class="social-link"><a class="iconfont icon-weixin"target="_blank"></a></li>
					<li class="social-link"><a class="iconfont icon-wifi"target="_blank"></a></li>
				</ul>
			</div>
			<div class="footer-nav hide-print">
				<ul class="utility-links">
					<li class="utility-link"><a>Disclaimers</a></li>
					<li class="utility-link"><a>Privacy &amp; Cookies Statement</a></li>
					<li class="utility-link"><a class="ot-sdk-show-settings" title="Manage Choices">Cookie
							Preferences</a></li>
					<li class="utility-link"><a>CCPA Privacy Disclosures</a></li>
					<li class="utility-link"><a>Contact Us</a></li>
					<li class="utility-link"><a>Media Contacts</a></li>
					<li class="utility-link"><a>Blogs</a></li>
					<li class="utility-link"><a>BM Online</a></li>
				</ul>

			</div>
			<div class="copyright">
				<p><span>Attorney Advertising | © 2024 Baker McKenzie</span></p>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '../../components/header.vue'

	export default {
		name: 'app',
		components: {
			Header
		},
		data() {
			return {
				trialShow: false,
				menuIndex: 1,
				swiperOption: {
					loop: false, //是否循环轮播
					speed: 1000, //切换速度
					observer: true, //修改swiper自己或子元素时，自动初始化swiper
					observeParents: true, //修改swiper的父元素时，自动初始化swiper
					//自动轮播
					autoplay: {
						delay: 2000,
						disableOnInteraction: false,
					},
					//设置slider容器能够同时显示的slides数量
					slidesPerView: 1,
					//左右切换
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
					//分页器
					pagination: {
						el: ".swiper-pagination",
						clickable: true, // 允许点击小圆点跳转
					},
				},
				bannerList: [
					// require('../../assets/image/adv.png'),
					// require('../../assets/image/17709.png'),
					// require('../../assets/image/17701.png'),
					// require('../../assets/image/17702.png'),
					// require('../../assets/image/17703.png'),
				],
				topicBgList: [
					require('../../assets/test/53.jpeg'),
					require('../../assets/test/ft-big-deal.webp'),
					require('../../assets/test/ft1.jpeg'),
					require('../../assets/test/ft2.webp')
				],
				toppicIndex: 0,
				headerMini: false,
				thresholdHeight: 100
			}
		},
		mounted() {
			 window.addEventListener('scroll', this.checkScrollPosition);
		},
		beforeDestroy() {
		    // 在组件销毁前移除滚动监听
		    window.removeEventListener('scroll', this.checkScrollPosition);
		},
		methods: {
			openTrialShow() {
				this.trialShow = true
			},
			toPage(path) {
				this.$router.replace(path);
			},
			changeTopicBg(e) {
				this.toppicIndex = e
			},
			checkScrollPosition() {
			    this.headerMini = window.scrollY >= this.thresholdHeight;
			},
		}
	}
</script>

<style lang='scss' scoped>
	.body-container {
		width: 100%;
		/* min-width: 1280px; */
		min-height: 100vh;
		overflow: hidden;
		position: relative;
		background-color: #fff;
	}

	.home-hero__wrapper {
		width: 100%;
		height: 1015px;
		overflow: hidden;
		position: relative;

		.hero-bg {
			background-image: url('../../assets/test/1.jpeg');
			background-size: 100% 100%;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 950px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.home-hero__headline {
			max-width: 864px;
			margin: 284px 0 50px 80px;
			position: relative;
			z-index: 1;

			h1 {
				color: #FFF;
				font-size: 90px;
				line-height: 1;
				text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.15);
				margin-bottom: 15px;
			}

			.home-hero__link {
				color: #FFF;
				font-size: 1.25em;
				font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
				font-weight: normal;
				font-style: normal;
				font-weight: 600;
				line-height: 1;
			}

			.link--bold {
				text-transform: uppercase;
				padding-right: 18px;
				-ms-flex-align: center;
				align-items: center;
				position: relative;
				transition: padding 0.4s ease-in-out;
			}

			.ab-link-block {
				height: auto;
				display: flex;
				align-items: center;
			}

			.link--bold-txt {
				float: left;
				margin-right: 12px;
			}

			.link-spre {
				float: left;
				width: 0;
				height: 2px;
				background-color: #fff;
				margin-right: -5px;
				transform: translate(0);

			}

			.icon-xiangyou1 {
				font-size: 19px;
			}

			.ab-link-block:hover {
				.link-spre {
					width: 25px;
					animation: example1 1s ;
				}

				@keyframes example1 {
					from {
						width: 0;
					}
					
					to {
						width: 25px;
						/* 或者你想要的任何长度 */
					}
				}


			}
		}

		.hero-insights {
			width: 100%;
			height: 367px;
			display: flex;
			position: relative;
			z-index: 1;
			overflow: hidden;

			h3 {
				float: left;
				margin-left: 80px;
				font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
				font-weight: normal;
				font-style: normal;
				font-size: 1.125em;
				color: #FFF;
				text-transform: uppercase;
				padding-top: 45px;
				width: calc(25% - 145px);
				padding-right: 145px;
				font-weight: bold;
			}

			.hero-insights__featured {
				float: right;
				display: -ms-flexbox;
				display: flex;
				width: 75%;
				position: relative;
				z-index: 1;
				padding: 3rem 0 3.75rem;
				background: linear-gradient(108.99deg, #ad122a -0.16%, #790123 153.62%);
			}

			.hero-insights__insight {
				font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
				font-weight: normal;
				font-style: normal;
				width: 33.33%;
				padding: 0 45px;

				.carousel-content {
					-ms-flex-align: start;
					align-items: flex-start;
					display: flex;
					flex-flow: row nowrap;
					vertical-align: middle;
					float: left;
				}

				.hero-insights__link {
					color: #FFF;
					position: relative;
					display: block;
				}

				.hero-insights__link {
					color: #FFF;
					position: relative;
					display: block;
				}

				a {
					color: #ad122a;
					transition: color 0.4s, background-color 0.4s;
				}

				.hero-insights__title,
				.home-hero .hero-insights__link a {
					color: #FFF;
					font-size: 24px;
					font-weight: bold;
					line-height: 1.5;
				}

				.link-spre {
					width: 0;
					height: 2px;
					background-color: #fff;
					margin: 0 0 20px;
					transform: translate(0);
				}
			}

			.hero-insights__insight:hover {
				.link-spre {
					width: 100%;
					animation: grow 1s;
				}

				@keyframes grow {
					from {
						width: 0;
					}

					to {
						width: 100%;
						/* 或者你想要的任何长度 */
					}
				}
			}
		}
	}

	.cta-module-section {
		max-width: 54.9375em;
		margin: 3.75em auto;
		position: relative;
		overflow: hidden;
		height: auto;

		.cta-intro__inner {
			text-align: center;
			width: 100%;
			height: auto;
			overflow: hidden;

			.cta-intro__header {
				width: 100%;
				font-size: 36px;
				line-height: 1.25;
				font-weight: bold;
				margin: 10px 0 20px;
			}

			.cta-intro__copy {
				width: 100%;
				padding: 25px 0;
				font-size: 20px;
			}

			.cta-link-block {
				height: auto;
				display: flex;
				align-items: center;
				color: #ad122a;
				justify-content: center;
				cursor: pointer;

				.link--bold-txt {
					text-transform: uppercase;
					font-weight: bold;
					font-size: 14px;
					line-height: 15px;
					padding-right: 2px;
					-ms-flex-align: center;
					align-items: center;
					position: relative;
					transition: padding 0.4s ease-in-out;
				}

				.link-spre {
					width: 0;
					height: 2px;
					background-color: #ad122a;
					margin: 0 -4px 0 5px;
					transform: translate(0);
				}

				.icon-xiangyou1 {
					font-size: 14px;
				}
			}

			.cta-link-block:hover {
				.link-spre {
					width: 25px;
					animation: grow2 1s;
				}

				@keyframes grow2 {
					from {
						width: 0;
					}

					to {
						width: 25px;
						/* 或者你想要的任何长度 */
					}
				}
			}
		}
	}

	.topic-selector {
		width: 100%;
		height: auto;
		overflow: hidden;
		position: relative;
		/* background-image: url('../../assets/test/ft-big-deal.webp'); */
		background-repeat: no-repeat;
		background-size: 100% 100%;

		.topic-selector__background {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			background-color: #000;
			opacity: .6;
		}

		.topic-selector__tiles--four-grid {
			display: flex;
			flex-wrap: wrap;
			position: relative;
			z-index: 1;

			.topic-selector__header {
				min-height: 398px;
				width: calc(50% - 2px);
				border: none;
				border-bottom: 1px solid #FFF;
				display: flex;
				align-items: flex-end;
				position: relative;
				color: #fff;
				overflow: hidden;
				font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
				font-size: 48px;

				font-weight: bold;

				.topic-selector__tile {
					line-height: 140px;
					text-indent: 40px;
				}

				.topic-selector__title {
					font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
					font-weight: normal;
					font-style: normal;
					font-size: 24px;
					font-weight: 500;
					padding-right: 40px;
					line-height: 1.5;
					margin-bottom: 40px;
				}
			}

			.topic-card-inner {
				cursor: pointer;
			}

			.topic-selector__header:nth-child(n+2) {
				justify-content: flex-end;
			}

			.topic-selector__header:nth-child(even) {
				border-left: 1px solid #FFF;
			}

			.topic-selector__card {
				color: #FFF;
				background-color: #ad122a;
				position: absolute;
				top: 100%;
				left: 0;
				width: 100%;
				min-height: 100%;
				transition: top 0.4s ease-in-out;
				display: -ms-flexbox;
				display: flex;
				-ms-flex-direction: column;
				flex-direction: column;
				-ms-flex-pack: center;
				justify-content: center;
				font-size: 18px;
				text-indent: 0;

				.topic-selector__card-inner {
					padding: 2.1875rem;

					.topic-selector__card-title {
						font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
						font-weight: normal;
						font-style: normal;
						font-size: 48px;
						line-height: 1.1666;
						font-weight: bold;
					}

					.topic-selector__card-content {
						margin: 1em 0 3.5em;
						line-height: 1.5;
					}

					.topic-selector__card-link {
						color: #FFF;
						line-height: 1.5;

						.link--bold-white {
							color: #FFF;
							font-weight: bold;
							text-transform: uppercase;
							font-size: 14px;
							margin-right: 0;
							line-height: 1.5;
							transition: padding 0.4s ease-in-out, margin 0.4s ease-in-out;
						}
					}
				}
			}

			.topic-selector__header:hover {

				.topic-selector__card {
					top: 0;
				}

			}
		}
	}

	.global-module.stats-module,
	.global-module.cta-module-section {
		padding: 0;
		margin-top: 3.75em;
		margin-bottom: 3.75em;
	}

	.stats-module {
		font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
		font-weight: normal;
		font-style: normal;
		background: linear-gradient(108.99deg, #ad122a -0.16%, #790123 153.62%);
		overflow: hidden;

		.page-wrapper {
			overflow: hidden;
			padding-top: 1.5em;
			padding-bottom: 1.5em;
		}

		.stats-module__stat {
			float: left;
			width: 33.3333%;
			color: #FFF;
			font-weight: bold;
			position: relative;
			margin: 60px 0;
			display: -ms-flexbox;
			display: flex;
			-ms-flex-direction: column;
			flex-direction: column;
			-ms-flex-align: center;
			align-items: center;
			-ms-flex-pack: center;
			justify-content: center;
		}

		.stats-module__stat.scroll-animate--animated .stats-module__stat-number,
		.stats-module__stat.scroll-animate--animated .stats-module__stat-label {
			opacity: 1;
		}

		.stats-module__stat.scroll-animate .stats-module__stat-number,
		.stats-module__stat.scroll-animate .stats-module__stat-label {
			transition: opacity 0.4s ease-in-out;
			transition-delay: 300ms;
		}

		.stats-module__stat-number {
			font-size: 58px;
			line-height: 1;
			position: relative;
			z-index: 1;
		}

		.stats-module__stat-label {
			font-size: 1.5em;
			line-height: 1;
			position: relative;
			z-index: 1;
		}

		.stats-module__stat.scroll-animate--animated .stats-module__stat-shadow {
			opacity: 1;
			transform: translateX(0);
		}

		.stats-module__stat.scroll-animate .stats-module__stat-shadow {
			transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
		}

		.stats-module__stat:nth-child(-n+3) .stats-module__stat-shadow {
			/* transform: translateX(-300px); */
		}

		.stats-module__stat-shadow {
			font-size: 105px;
			margin-top: -128px;
			color: #790123;
		}

		.stats-module__stat-shadow {
			font-size: 88px;
		}
	}

	.cta-module-section2 {
		padding: 0;
		margin-top: 3.75em;
		margin-bottom: 3.75em;
		display: flex;
		max-width: 79.875em;
		margin-left: auto;
		margin-right: auto;
		position: relative;

		.call-to-action-module {
			float: left;
			width: 35%;

			.title {
				font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
				font-weight: normal;
				font-style: normal;
				font-size: 36px;
				line-height: 1.25;
				font-weight: bold;
				padding: 1.5em 3em 1.5em 0.5em;
			}

			.content {
				background-color: #FFF;
				padding: 100px 130px;
				position: relative;
				width: 295px;
				font-size: 1.125em;
			}

			.call-to-action__content {
				z-index: 1;

				.summary {
					margin-bottom: 1em;
					word-break: break-word;
				}

				.cta-link-block {
					height: auto;
					display: flex;
					align-items: center;
					color: #ad122a;
					cursor: pointer;

					.link--bold-txt {
						text-transform: uppercase;
						font-weight: bold;
						font-size: 14px;
						line-height: 15px;
						padding-right: 5px;
						-ms-flex-align: center;
						align-items: center;
						position: relative;
						transition: padding 0.4s ease-in-out;
						color: #ad122a;
					}

					.link-spre {
						width: 0;
						height: 2px;
						background-color: #ad122a;
						margin: 0 -4px 0 5px;
						transform: translate(0);
					}

					.icon-xiangyou1 {
						font-size: 14px;
					}
				}

				.cta-link-block:hover {
					.link-spre {
						width: 25px;
						animation: grow3 1s;
					}

					@keyframes grow3 {
						from {
							width: 0;
						}

						to {
							width: 25px;
							/* 或者你想要的任何长度 */
						}
					}
				}
			}
		}

		.call-img {
			float: left;
			opacity: 1;
			transform: translateX(0);
			width: 65%;
			height: 620px;
			background-image: url('../../assets/test/5.webp');
			background-size: 100% 100%;
		}
	}
	.global-footer, .global-footer-social {
	    font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
	    font-weight: normal;
	    font-style: normal;
	    background: linear-gradient(108.99deg, #ad122a -0.16%, #790123 153.62%);
	    padding-top: 4.375em;
	    padding-bottom: 3.125em;
		
		.communication-footer {
		    text-align: center;
			
			.social-links {
			    display: inline-block;
				
				.social-link {
				    display: inline-block;
				    margin-left: 1rem;
				    margin-right: 1rem;
				    vertical-align: middle;
				    font-size: 1.75em;
					
					a {
					    color: #FFF;
						vertical-align: -6.14286%;
						line-height: 1;
					}
					.iconfont {
						font-size: 32px;
					}
				}
			}
		}
		.footer-nav{
		    margin-left: 1.5em;
		    margin-right: 1.5em;
			border-top: 1px solid #cececd;
			max-width: 79.875em;
			padding: 1.5em 0 0;
			
			.utility-links{
			    font-size: 1.125em;
				display: flex;
				justify-content: space-between;
				
				.utility-link {
				    color: #FFF;
					display: inline-block;
					padding-right: 1em;
					
					a {
					    color: #FFF;
					}
				}
			}
		}
		.copyright {
			margin-left: 1.5em;
			margin-top: 1.5em;
			color: #FFF;
			max-width: 79.875em;
			margin-right: 1.5em;
			padding: 0;
			text-align: center;
		}
	}
	@media screen and (max-width: 61.9375em){
		.home-hero__wrapper {
		    height: 740px;
		}
		.hero-bg {
		    background-size: cover !important;
		    overflow: hidden;
		    position: relative;
			background-position: 46% 50%;
		}
		.home-hero__headline {
		    padding-top: 150px;
			margin: 0 40px 0 20px !important;
		}
		.home-hero__headline h1 {
		    font-size: 38px !important;
		}
		.home-hero__wrapper .hero-insights {
		    margin-left: 80px;
		    display: block !important;
		}
		.home-hero__wrapper .hero-insights h3 {
		    display: none !important;
		}
		.home-hero__wrapper .hero-insights .hero-insights__featured {
		    display: block;
		    overflow: hidden;
		    width: 100%;
		    padding: 1.875rem 0;
		}
		.home-hero__wrapper .hero-insights .hero-insights__insight{
		    width: 56.33%;
		    padding: 0 35px;
			display: none;
		}
		.home-hero__wrapper .hero-insights .hero-insights__insight .hero-insights__title {
			font-size: 20px;
		}
		.home-hero__wrapper .hero-insights .hero-insights__insight:first-child{
			display: block;
		}
		.topic-selector .topic-selector__tiles--four-grid .topic-selector__header .topic-selector__title{
			padding-right: 0;
			padding-left: 20px;
			margin-bottom: 20px;
		}
		.topic-selector .topic-selector__tiles--four-grid .topic-selector__header {
			font-size: 25px;
			font-weight: unset;
		}
		.topic-selector .topic-selector__tiles--four-grid .topic-selector__header .topic-selector__tile {
			line-height: 30px;
			text-indent: 0;
			padding-left: 20px;
			margin-bottom: 20px;
		}
		.global-module.stats-module {
		    padding: 0;
		    margin-top: 3.75em;
		    margin-bottom: 3.75em;
		}
		.stats-module .stats-module__stat {
			width: 100%;
		}
		.cta-module-section2 {
			display: block;
			overflow: hidden;
		}
		.cta-module-section2 .call-to-action-module {
		    width: 100%;
		    padding: 1em;
		    margin-bottom: -5em;
		    position: relative;
		    background-color: #FFF;
		}
		.cta-module-section2 .call-to-action-module .title {
		    font-size: 24px;
		    padding: 0;
		}
		.cta-module-section2 .call-to-action-module .content {
		    position: relative;
		    min-width: 0;
		    width: auto;
		    padding: 0;
		    background-color: transparent;
		}
		.cta-module-section2 .call-to-action-image.scroll-animate--animated {
		    width: 100%;
		}
		.cta-module-section2 .call-img {
			 width: 100%;
			 transform:unset;
			 height: 250px;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.global-footer .footer-nav .utility-links, .global-footer-social .footer-nav .utility-links {
		    display: -ms-flexbox;
		    display: flex;
		    -ms-flex-direction: row;
		    flex-direction: row;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    text-align: left;
		    padding: 0;
		    -ms-flex-align: center;
		    align-items: center;
		}
		.global-footer .footer-nav .utility-links .utility-link, .global-footer-social .footer-nav .utility-links .utility-link {
		    width: 38%;
		    padding-bottom: 1em;
		    padding-right: 0;
		    padding-left: 20px;
		    min-height: 40px;
		}
		.global-footer .copyright, .global-footer-social .copyright {
		    display: block;
		    text-align: center;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.global-footer .communication-footer .social-links .social-link .iconfont, .global-footer-social .communication-footer .social-links .social-link .iconfont{
			font-size: 25px;
		}
		.global-footer .communication-footer .social-links {
			padding: 0;
		}
		.topic-selector .topic-selector__tiles--four-grid .topic-selector__card {
			display: none;
		}
	}
</style>
